import type { SalonStockerHttpTypes } from "@repo/api-sdk";
import sdk from "@repo/api-sdk";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { queryKeys } from "./queryKeys";

// /**
//  * Optional fields: "external_id" | "meta"
//  */
// type ProductOptionalField =
//   keyof SalonStockerHttpTypes.StoreProductPreviewOptionalFields;

// /**
//  * Query parameters with type-safe fields parameter.
//  */
// export type SaleProductsQueryParams<
//   TInclude extends ProductOptionalField = never
// > = Omit<SalonStockerHttpTypes.StoreSaleProductsParams, "fields"> & {
//   fields?: [TInclude] extends [never]
//     ? string
//     : `+${TInclude}` | `${string}+${TInclude}${string}`;
// };

// export function saleProductsQuery<
//   TInclude extends ProductOptionalField = never
// >(query?: SaleProductsQueryParams<TInclude>) {
//   const defaultQuery: SaleProductsQueryParams<TInclude> = {
//     limit: 4
//   } satisfies SaleProductsQueryParams<TInclude>;

//   const finalQuery = { ...defaultQuery, ...query };

//   return queryOptions({
//     queryKey: queryKeys.saleProducts(finalQuery),
//     queryFn: () => {
//       return sdk.store.product.listSale<TInclude>(finalQuery);
//     }
//   });
// }

type SaleProductsQueryParams = SalonStockerHttpTypes.StoreProductSaleListParams;

export function saleProductsQuery(query?: SaleProductsQueryParams) {
  const defaultQuery: SaleProductsQueryParams = {
    limit: 20
  } satisfies SaleProductsQueryParams;

  const finalQuery = { ...defaultQuery, ...query };

  return queryOptions({
    queryKey: queryKeys.saleProducts(finalQuery),
    queryFn: () => sdk.store.product.listSale(finalQuery)
  });
}

// Implementation
export function useSaleProducts(
  query?: SaleProductsQueryParams,
  options?: {
    enabled?: boolean;
  }
) {
  return useQuery({
    ...saleProductsQuery(query),
    ...options
  });
}
